import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialPersonnelState: Dtos.TrialPersonnel & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    institutionId: null,
    institution: null,
    groupId: null,
    group: null,
    personnelId: null,
    personnel: null,
    positionNo: null,
    groupLevelTypeId: null,
    groupLevelType: null,
    roleId: null,
    role: null,
    dateStarted: null,
    dateCeased: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    active: null,
    saveAndReturn: false,
}

export interface ITrialPersonnelReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    institutionId: IFieldState<number>,
    groupId: IFieldState<number>,
    personnelId: IFieldState<number>,
    positionNo: IFieldState<number>,
    groupLevelTypeId: IFieldState<number>,
    roleId: IFieldState<number>,
    dateStarted: IFieldState<string>,
    dateCeased: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
